// 連線定義（2026-06-15 更新）—— 取自 Unity 權威 lines.json：
//   {"lines":[[0,0,0],[1,1,1],[2,2,2],[0,1,2],[2,1,0]]}
// 每條長度 = 轉輪數，元素為「該輪取盤面第幾排」的 row index。
//
// 重點：
//  - 順序固定，且必須與後端 `mgLineCount` / `mgLineWin` 對應（第 i 條線 ↔ index i）。
//  - row index 與盤面資料 `board[reel][row]`（= 後端 MGSymbol）同一套索引，可直接索引並對位高亮。
//    （已用實機中獎資料驗證：後端 line 0 = board[reel][0] 這一排，與 mgLineCount[0] 相符。）
//  - 5 條 = 三排（row 0/1/2）+ 兩條對角，與遊戲 PAYLINE 表一致。
export const PAYLINES: readonly (readonly number[])[] = [
  [0, 0, 0], // 第 1 排（三輪同排）
  [1, 1, 1], // 第 2 排
  [2, 2, 2], // 第 3 排
  [0, 1, 2], // 對角：reel0 row0 → reel1 row1 → reel2 row2
  [2, 1, 0], // 對角：reel0 row2 → reel1 row1 → reel2 row0
]

/** 取得本遊戲的連線定義（回傳複本，避免外部變更共用參照）。 */
export function defaultPaylines(): number[][] {
  return PAYLINES.map((line) => [...line])
}
